import type { GsEvent } from '@/lib/types';

export default function EventFacts({ event }: { event: GsEvent }) {
  const facts = [
    { label: 'Course', value: event.course },
    { label: 'County', value: event.county ? `${event.county} County` : event.city },
    { label: 'Entry fee', value: event.entry_fee || 'See organizer' },
    { label: 'Organizer', value: event.organizer || event.host || 'To be announced' },
    { label: 'Beneficiary', value: event.charity || event.benefits || 'To be announced' },
    { label: 'Status', value: event.status },
  ];

  return (
    <section className="bg-primary-500 grid grid-cols-2 lg:grid-cols-3">
      {facts.map((f) => (
        <div key={f.label} className="px-4 md:px-8 py-5 md:py-6 border-r border-b border-primary-400">
          <p className="font-label uppercase text-xs tracking-widest text-accent-400">{f.label}</p>
          <p className="font-heading font-bold uppercase text-lg md:text-xl text-background-50 mt-1">{f.value}</p>
        </div>
      ))}
    </section>
  );
}